/**
 * Returns an array of selected elements suitable for the updateColumnItemContentInMultipleBlock reducer
 * @param {object} selected The local selection state
 */
export default (selected) => Object.entries(selected).map(([elmIdx, elm]) => {
    const { blockIndex, columnIdx, type } = elm;
    return {
        blockIndex, columnIdx, elmIdx, type,
    };
});
